import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { FiGrid, FiLogOut, FiMenu, FiX } from "react-icons/fi";
import { useState } from "react";
import logo from "../../assets/logo/logo.png";
import { clearAdminAuth } from "../adminStorage";
import "./AdminLayout.css";

export default function AdminLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const auth = (() => {
    try {
      return JSON.parse(localStorage.getItem("yadnya_admin_auth")) || {};
    } catch {
      return {};
    }
  })();

  // const logout = () => {
  //   clearAdminAuth();
  //   navigate("/admin/login", { replace: true });
  // };
  const logout = () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (!confirmed) return;
    clearAdminAuth();
    navigate("/", { replace: true });
  };

  return (
    <div className="admin-shell">
      <aside className={`admin-sidebar ${mobileOpen ? "open" : ""}`}>
        <div className="admin-brand">
          <img src={logo} alt="Yadnya Handloom" />
          <div>
            <strong>YADNYA</strong>
            <span>HANDLOOM</span>
          </div>
        </div>

        <nav className="admin-nav">
          <NavLink
            to="/admin/dashboard"
            onClick={() => setMobileOpen(false)}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FiGrid />
            Dashboard
          </NavLink>
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-mini">
            <span>{(auth.name || "Admin").slice(0, 1).toUpperCase()}</span>
            <div>
              <strong>{auth.name || "Admin"}</strong>
              <small>{auth.role || "Administrator"}</small>
            </div>
          </div>

          <button onClick={logout} className="admin-logout">
            <FiLogOut />
            Logout
          </button>
        </div>
      </aside>

      {mobileOpen && (
        <button
          className="admin-mobile-overlay"
          aria-label="Close menu"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <main className="admin-main">
        <header className="admin-topbar">
          <button
            className="admin-mobile-menu"
            onClick={() => setMobileOpen((value) => !value)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <FiX /> : <FiMenu />}
          </button>

          <div>
            <p>Yadnya Handloom</p>
            <span>Admin Panel</span>
          </div>

          <div className="admin-topbar-right">
            <span className="admin-status-dot" />
            <span>Admin</span>
          </div>
        </header>

        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
